import { useQuery } from '@tanstack/react-query';
import { RestCountry } from '../types/common';
import { returnQueryConfig } from '../utils/commonFunctions';

// custom hook to fetch country details declared here
const useRestCountries = (): Array<RestCountry> | undefined => {
  //integration of tanstack query hooks here
  const queryResult = useQuery({
    queryKey: ['countries'],
    queryFn: async (): Promise<Array<RestCountry>> => {
      const response = await fetch(
        process.env.REACT_APP_REST_COUNTRIES_API as string
      );

      console.log('FETCHING COUNTRIES!!');

      return response.json();
    },

    ...returnQueryConfig(true),
  });

  return queryResult.data !== undefined
    ? queryResult.data.sort((a, b) =>
        a.name.common.localeCompare(b.name.common)
      )
    : queryResult.data;
};

export default useRestCountries;
